/* eslint import/prefer-default-export: off */
const { BVVars } = window;

export const v = (varName) => BVVars[varName];
